import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './OilTankComponent.metadata.json5';

function OilTankComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OilTankComponentt');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthPledesthelocFie: {
            visible: !_.isUndefined(_.get(modelVM, 'wheistheOilTanlocFie.value.code')) && _.get(modelVM, 'wheistheOilTanlocFie.value.code') === 'Other'
        },
        ifYESwheisitloconttanFie: {
            visible: !_.isUndefined(_.get(modelVM, 'istheanyrusdenorevcorFie.value')) && _.get(modelVM, 'istheanyrusdenorevcorFie.value')
        },
        ifnoPledesthetypofbasFie: {
            visible: !_.isUndefined(_.get(modelVM, 'isthetanresonnonbabasFie.value')) && _.get(modelVM, 'isthetanresonnonbabasFie.value') === false
        },
        ifnoPleprodatoflasserFie: {
            visible: !_.isUndefined(_.get(modelVM, 'doequapersertheOilyeaFie.value')) && _.get(modelVM, 'doequapersertheOilyeaFie.value') === false
        },
        ageoftheOilTanFie: {
            readOnly: true
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if (changedPath === 'yeaInsFie' && modelVM.value.yeaInsFie.length === 4) {
                const age = new Date().getFullYear() - _.get(modelVM, 'yeaInsFie.value')

                _.set(modelVM, 'ageoftheOilTanFie.value', age)
            }

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OilTankComponent.propTypes = wizardProps;
export default withRouter(OilTankComponent);